import React from 'react';
import {
  Grid,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  Box
} from "@mui/material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AlarmOnIcon from '@mui/icons-material/AlarmOn';
import { useNavigate } from 'react-router-dom';
import { RegisterUsabilityLog } from '../../../shared/data-services/ModuleUsabilityLog-service';

const ContentLasa = ({ user }) => {
  const name = user.name;
  const navigate = useNavigate();

  const handleQuickAccess = async (route, logText) => {
    await RegisterUsabilityLog(logText, user.employeeId);
    navigate(route);
  };
return (
  <Grid container spacing={2}>
    <Grid item xs={12} md={6}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h5" style={{ color: '#8ebb37' }} fontWeight="bold" sx={{ m: 1 }}>
            <b>Hola {name}!</b>
          </Typography>
          <Typography variant="h5" style={{ color: '#1a3072' }} fontWeight="bold" sx={{ m: 1 }}>
            <i>Bienvenido a Tu experiencia <span style={{ color: '#00b0ef' }}><b>Talma</b></span></i>
          </Typography>
        </Grid>

        <Grid item xs={12} style={{ marginBottom: 20 }}>
          <iframe
            width="100%"
            height="415"
            src="https://www.youtube.com/embed/muy1rjjA21A"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </Grid>

        {/* Botones envueltos correctamente */}
        <Grid item xs={12}>
          <Grid container spacing={2}  sx={{ mt: 2 }}>
            {/* Botón: Mis Turnos */}
            <Grid item xs={6} sm={4} md={3}>
              <Card sx={{ maxWidth: 200, mx: "auto", backgroundColor: "#00000008" }}>
                <CardActionArea
                  onClick={() => handleQuickAccess('/ShiftCalendar', 'Mis Turnos - Autogestión')}
                  sx={{ textAlign: "center" }}
                >
                  <CalendarMonthIcon sx={{ fontSize: 60, color: "#27b9d4" }} />
                  <CardContent sx={{ p: 0 }}>
                    <Typography variant="h6" sx={{ color: "#8ebb37", fontWeight: "bold", m: 0 }}>
                      Consulta de
                    </Typography>
                    <Typography variant="h6" sx={{ color: "#1a3072", fontWeight: "bold" }}>
                      Mis Turnos
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>

            {/* Botón: Mis Marcaciones */}
            <Grid item xs={6} sm={4} md={3}>
              <Card sx={{ maxWidth: 200, mx: "auto", backgroundColor: "#00000008" }}>
                <CardActionArea
                  onClick={() => handleQuickAccess('/EmployeeWorkShif', 'Mis Marcaciones - Autogestión')}
                  sx={{ textAlign: "center" }}
                >
                  <AlarmOnIcon sx={{ fontSize: 60, color: "#27b9d4" }} />
                  <CardContent sx={{ p: 0 }}>
                    <Typography variant="h6" sx={{ color: "#8ebb37", fontWeight: "bold", m: 0 }}>
                      Consulta de
                    </Typography>
                    <Typography variant="h6" sx={{ color: "#1a3072", fontWeight: "bold" }}>
                      Mis Marcaciones
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>

    <Grid item xs={12} md={6}>
      <img src="./Images/hom_tu_experiencia.jpg" alt="logo" style={{ width: '100%', height: '90%' }} />
    </Grid>
  </Grid>
);
}

export default ContentLasa;